import React from 'react';
import HclApiManager from "../../../Api/HclApiManager";
import HCLTreeMxGraph from "../../../mxGraph/HCLTreeMxGraph/HCLTreeMxGraph";
import TreeProps from 'hcla-web-frontend-primitives/app/Props/TreeProps';
import { HCLTreeMxGraphViewJSON } from "./SingleTreeView/MxGraphViews/HCLTreeMxGraphView";

// @ts-ignore
export const TreeContext = React.createContext({} as TreeContextProps);

export interface TreeMetaData {
  creator: string;
  date_created: string;
  date_modified: string;
  description: string;
  id: number;
  title: string;
  tree_type: string;
  valid: boolean;
}

interface TreeContextProps {
  treeId: number;
  detailsWithMetaData: TreeProps;
  onRequestSave: (event: any, data: any) => {};
  isSavingInProgress: boolean;
  isLoadingInProgress: boolean;
  basePath: string;
  isHCLFlatList: boolean;
  riskCurves?: { [key: string]: any }
  lineLevelRiskCurves?: { [key: string]: any };
}

interface Props {
  treeId: number;
  basePath: string;
  isHCLFlatList: boolean;
  riskCurves?: { [key: string]: any };
  lineLevelRiskCurves?: { [key: string]: any };
}

interface State {
  detailsWithMetaData: TreeMetaData;
  isSavingInProgress: boolean;
  isLoadingInProgress: boolean;
}

export default class TreeContextProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      detailsWithMetaData: null,
      isSavingInProgress: false,
      isLoadingInProgress: true,
    };
  }

  componentDidMount(): void {
    const { treeId } = this.props;
    HclApiManager.getHclTreeWithMetadata(treeId)
      .then((response: any) => (response.ok ? response.json() : null))
      .then((data: any) => this.setState({
        detailsWithMetaData: data,
        isLoadingInProgress: false
      }));
  }

  private updateComponentData = (event: any, data: any) => {
    this.setState({ isSavingInProgress: true });
    const { treeId } = this.props;
    return HclApiManager.patchHclTreeMetadata(treeId, data)
      .then((response: { status: number; json: () => void }) => response.status === 200 && response.json())
      .then((res: any) => {
        this.setState({ detailsWithMetaData: res, isSavingInProgress: false, isLoadingInProgress: false });
        return res;
      });
  };

  private handleOnRequestSaveData = (event: any, data: any) => {
    const payload = {
      ...data,
    };
    return this.updateComponentData(event, payload);
  };

  render() {
    const { detailsWithMetaData, isLoadingInProgress, isSavingInProgress } = this.state;
    const { treeId, basePath, isHCLFlatList, children, riskCurves, lineLevelRiskCurves } = this.props;
    return (
      <TreeContext.Provider
        value={{
          //@ts-ignore
          detailsWithMetaData,
          isSavingInProgress,
          isLoadingInProgress,
          onRequestSave: this.handleOnRequestSaveData,
          treeId,
          basePath,
          isHCLFlatList,
          riskCurves,
          lineLevelRiskCurves
        }}
      >
        {children}
      </TreeContext.Provider>
    );
  }
}






